(function languageswitcherScript($, Drupal) {
  Drupal.behaviors.inlineFormBehaviour = {
    attach(context) {

    },
  };
}(jQuery, Drupal));
